import React, { Component } from "react";
import EkoModal from "../../components/elements/EkoModal";
import EkoInputTable from "../../components/elements/EkoInputTable";
import { toastr } from "react-redux-toastr";
import Util from "../../util/Util";
import Api from "../../util/Api";
class PrefixModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [this.row],
            errors: {
                rows: []
            },
            saving: false,
            hideAddButton: true,
            formData:this.props.prefixRows
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.showPrefixModal !== this.props.showPrefixModal && this.props.showPrefixModal) {
            this.setState({ formData: this.props.prefixRows })
        }
    }
    get row() {
        return [
            {
                label: "",
                placeholder: "Önek",
                type: "text",
                colMd: 12,
                id: "prefix_name"
            },
            {
                label: "",
                placeholder: "Son Numara",
                type: "text",
                colMd: 12,
                id: "last_number"
            },
        ];
    }

    checkValid = data => {
        return !!(data && data !== "");
    };

    onSave = () => {
        const errors = this.checkErrors();
        this.setState({ errors: { rows: errors } });
        if (errors.length === 0) {
            this.props.closePrefixModal();
            //
            Api.post("/proforma/proformaRecordDocumentAddOrUpdate", {rows:this.state.formData.rows}, (data, errors) => {
                if (data) {
                }
            });
        }
        
    };

    checkErrors = () => {
        const rows = this.state.formData.rows;

        const errors = [];

        rows.map((row, index) => {
            if (row.prefix_name === "" || row.prefix_name === null) { return row; }

            if (this.checkValid(row.prefix_name) === false) {
                errors[index] = {
                    prefix_name: ["Lütfen Önek Seçiniz"]
                };
            }
            if (this.checkValid(row.last_number) === false) {
                errors[index] = {
                    last_number: ["Lütfen Son Numara Seçiniz"]
                };
            }
            return row;
        });

        return errors;
    };

    closeModal = () => {
        const errors = this.checkErrors();

        this.setState({ errors: { rows: errors } });

        if (errors.length > 0) {
            toastr.warning("Hatalı bir veri girdiniz, lütfen kontrol ediniz");
            return;
        }
        if (this.props.closePrefixModal && errors.length === 0) {
            this.props.closePrefixModal();
        }
    };
    savePrefix = (rows) => {
        this.setState({ formData: rows });
    };
    onChange = data => {
        this.savePrefix(data);
        this.props.savePrefix(data);
    };

    addRow = () => {
        const { formData } = this.state;
        const { rows } = formData;
        const lastRowIndex = rows.length - 1;
        const updatedRow = {
            ...rows[lastRowIndex],
            id:null,prefix_name:"",last_number: ""
        };
        const updatedRows = [...rows.slice(0, lastRowIndex), updatedRow];
        this.setState({
            formData: {
                ...formData,
                rows: updatedRows,
            },
        });
    };



    onRowDelete = () => {
        if(this.state.formData.rows.length<5){
            this.setState({ hideAddButton: true });
        }
        return false;
    };

    onChangeRow(index, value,input) {
        var data = this.state.formData;
        var row = data.rows[index];
        if(input==='rate'){
            var rate = value.rate.replace('%','');
            if(rate>100){
                row.rate = "%100,00";
            }
        }
        this.setState(
            {
                data:data
            }
        );
    }
    render() {
        return (
            <EkoModal
                bsSize={"large"}
                dialogClassName={""}
                showModal={this.props.showPrefixModal}
                title={"Önek Ekle"}
                onHide={this.closeModal.bind(this)}
                spinner={this.state.saving}
            >
                <EkoInputTable
                    onSave={this.onSave}
                    className={"modalTableFix"}
                    onCancel={this.closeModal}
                    onChange={this.onChange}
                    errors={this.state.errors}
                    formData={this.state.formData}
                    onRowAdd={this.addRow}
                    onRowDelete={this.onRowDelete}
                    hideAddButton={this.state.hideAddButton}
                    onChangeRow={this.onChangeRow.bind(this)}
                    data={{
                        headers: [{ label: "Önek" }, { label: "Son Numara" }],
                        rows: this.state.formData?.rows?.map(() => this.row)
                    }}
                />
            </EkoModal>
        );
    }
}

export default PrefixModal;
